import React from 'react';
import { at } from 'lodash';
import { useField, useFormikContext } from 'formik';
import { Autocomplete, TextField, Chip } from '@mui/material';
import { boolean } from 'yup';

function AutocompleteMultiples(props: any) {
  const { label, options, onChange, element, ...rest } = props;
  const formikProps = useFormikContext();
  const [field, meta] = useField(props);

  const selectedValue = field.value || [];
  const [touched, error] = at(meta, 'touched', 'error');

  function _renderHelperText() {
    if (touched && error) {
      if (typeof error === 'string') {
        return error;
      }
      if (Array.isArray(error)) {
        // If it's an array of errors (common in AutocompleteMultiple)
        const firstError = error.find(e => e !== undefined && e !== null);
        if (typeof firstError === 'string') return firstError;
        if (typeof firstError === 'object') {
           // If the error is inside an object { value: 'error', label: 'error' }
           return Object.values(firstError).find(v => typeof v === 'string') || '';
        }
      }
      if (typeof error === 'object') {
        return Object.values(error).find(v => typeof v === 'string') || '';
      }
    }
    return '';
  }

  return (
    <Autocomplete
      multiple
      disablePortal
      filterSelectedOptions
      options={options}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={(option: any) => {
        if (typeof option === 'string') return option;
        const labelText = option?.label || option?.value || '';
        return String(labelText).charAt(0).toUpperCase() + String(labelText).slice(1);
      }}
      loadingText="Cargando..."
      renderOption={(props, option: any) => {
        const { key, ...optionProps } = props;
        const labelText = option?.label || option?.value || '';
        const capLabel = String(labelText).charAt(0).toUpperCase() + String(labelText).slice(1);
        return (
          <li key={key} {...optionProps}>
            {capLabel}
          </li>
        );
      }}
      renderTags={(tagValue, getTagProps) =>
        tagValue.map((option: any, index: number) => {
          const { key, ...tagProps } = getTagProps({ index });
          const labelText = option?.label || option?.value || '';
          return (
            <Chip
              key={key}
              label={String(labelText)}
              {...tagProps}
              size="small"
              color="primary"
              variant="outlined"
            />
          );
        })
      }
      onBlur={() => formikProps.setFieldTouched(field.name)}
      onChange={(e, v) => {
        formikProps.setFieldValue(field.name, v); // Guarda en Formik
        if (typeof onChange === 'function') {
          onChange(e, v); // Llama al callback externo
        }
      }}
      value={Array.isArray(selectedValue) ? selectedValue : []}
      renderInput={(params) => {
        const { ...textFieldProps } = rest;
        return (
          <TextField
            {...params}
            {...textFieldProps}
            label={label}
            helperText={_renderHelperText()}
            error={Boolean(touched && error)}
          />
        );
      }}
    />
  );
}

AutocompleteMultiples.defaultProps = {
  options: [],
  name: '',
  label: '',
  setValue: '',
  element: '',
  isdisabled: boolean,
  onChange: () => {},
};

export default AutocompleteMultiples;
